import { ZfIcon, ZfPill, ZfStack, ZfTooltip } from '@zafire/react';
import type { ICellRendererParams } from 'ag-grid-enterprise';
import { useTranslation } from 'react-i18next';
import type { Notification } from '../../api/generated/client';

export const SessionTableNotificationCellRenderer = ({ value }: ICellRendererParams<{}, Notification>) => {
    const { t } = useTranslation();

    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <ZfStack direction="row" spacing="extra-small" alignment="center">
                {value?.overdueEvents ? (
                    <ZfTooltip text={t('eventNotification-OVERDUE')} style={{ display: 'flex' }}>
                        <ZfPill slot="anchor" size="small" color="yellow">
                            <ZfIcon slot="leading" name="warning" size="small" />
                            {value?.overdueEvents.toString()}
                        </ZfPill>
                    </ZfTooltip>
                ) : null}
                {value?.dueEvents ? (
                    <ZfTooltip text={t('eventNotification-DUE')} style={{ display: 'flex' }}>
                        <ZfPill slot="anchor" size="small" color="blue">
                            <ZfIcon slot="leading" name="lightbulb" size="small" />
                            {value?.dueEvents.toString()}
                        </ZfPill>
                    </ZfTooltip>
                ) : null}
            </ZfStack>
        </div>
    );
};
